module.exports = __webpack_public_path__ + "img/gongkai.51df8415.png";